<div class="left-panel-accordion ">
  <ul>
    <li>
      <mat-accordion>
        <ul>
          <li class="one-level">
            <div class="header pointer flex flex-row justify-between items-center" (click)="toggleOneLevel()">
              <span>Seep-by-Step Process</span>
              <div class="flex flex-row justify-start items-center">
                <i *ngIf="isOneLevelVisible" class="fa-solid fa-plus"></i>
                <i *ngIf="!isOneLevelVisible" class="fa-solid fa-minus"></i>
              </div>
            </div>


            <ul class="content" *ngIf="isOneLevelVisible">
              <li>
                <div class="single-item">
                  Import Entity Chart 1
                </div>
              </li>
              <li>
                <mat-accordion>
                  <ul>
                    <li class="two-level">
                      <div class="header flex flex-row" (click)="toggleTwoLevel()">
                        <i *ngIf="isTwoLevelVisible" class="fa-regular fa-angle-down"></i>
                        <i *ngIf="!isTwoLevelVisible" class="fa-regular fa-angle-right"></i>

                        <span>Import Entity Chart</span>


                      </div>


                      <ul class="content " *ngIf="isTwoLevelVisible">
                        <li>
                          <div class="single-item">Import Entity Chart</div>
                        </li>
                        <li>
                          <div class="single-item">Confirm FX Rates</div>
                        </li>
                        <li>
                          <div class="single-item">Confirm Applicable Input</div>
                        </li>
                        <li>
                          <mat-accordion>
                            <ul>
                              <li class="three-level">
                                <div class="header pointer flex flex-row" (click)="toggleThreeLevel()">
                                  <i *ngIf="isThreeLevelVisible" class="fa-regular fa-angle-down"></i>
                                  <i *ngIf="!isThreeLevelVisible" class="fa-regular fa-angle-right"></i>
                                  <span>Input / Upload Data by Entity</span>

                                </div>


                                <ul class="content" *ngIf="isThreeLevelVisible">
                                  <li>
                                    <div class="single-item">Confirm Source Currency</div>
                                  </li>
                                  <li>
                                    <div class="single-item">Input Data Manually</div>
                                  </li>
                                  <li>
                                    <div class="single-item">Upload Data form Source Files</div>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </mat-accordion>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </mat-accordion>
              </li>
            </ul>

            <mat-tree [dataSource]="dataSource"
                      [treeControl]="treeControl">
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>

                <!-- Adding disabled property to button
                    so as to give padding to nodes -->
                <button mat-icon-button disabled></button>
                {{node.title}}
              </mat-tree-node>

              <!-- Tree node template for expandable nodes -->
              <mat-tree-node
                *matTreeNodeDef="let node;when: hasChild"
                matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]=
                          "'Toggle ' + node.title">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ?
                    'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                {{node.title}}
              </mat-tree-node>
            </mat-tree>

          </li>
        </ul>
      </mat-accordion>
    </li>
  </ul>

</div>
